import { IImgMediaDto } from './i-img-media-dto';
import { ISponsoredAuthor } from './i-sponsored-author-dto';
import { IVideoMediaDto } from './i-video-media-dto';

export interface ISponsoredSection {
  headline?: string;
  standfirst?: string;
  body?: string;
  mainImage?: IImgMediaDto;
  mainVideo?: IVideoMediaDto;
  bodyImages?: IImgMediaDto[];
  bodyVideos?: IVideoMediaDto[];
  client?: string;
  salesOrder?: string;
  sponsoredAuthors?: ISponsoredAuthor[];
}
export class SponsoredSection implements ISponsoredSection {
  public client: string;
  public salesOrder: string;
  public headline: string;
  public standfirst: string;
  public body: string;
  public bodyImages: IImgMediaDto[];
  public bodyVideos: IVideoMediaDto[];
  public sponsoredAuthors: ISponsoredAuthor[];
  public mainImage: IImgMediaDto;
  public mainVideo: IVideoMediaDto;
  constructor({
    client,
    salesOrder,
    headline,
    standfirst,
    body,
    bodyImages,
    bodyVideos,
    sponsoredAuthors,
    mainImage,
    mainVideo,
  }: ISponsoredSection) {
    this.client = client;
    this.salesOrder = salesOrder;
    this.headline = headline;
    this.standfirst = standfirst;
    this.body = body;
    this.bodyImages = bodyImages ?? [];
    this.bodyVideos = bodyVideos ?? [];
    this.sponsoredAuthors = sponsoredAuthors ?? [];
    this.mainImage = mainImage;
    this.mainVideo = mainVideo;
  }
}
